import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=9fb59d34&scoped=true&"
var script = {}
import style0 from "./footers.vue?vue&type=style&index=0&id=9fb59d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb59d34",
  null
  
)

export default component.exports